var map = {
	"./bg/architecture.json": "ac39",
	"./bg/businessField.json": "83b2",
	"./bg/classify.json": "1a97",
	"./bg/companyCulture.json": "aa1e",
	"./bg/contactUs.json": "3f44",
	"./bg/footer.json": "1431",
	"./bg/header.json": "cf4b",
	"./bg/home.json": "8664",
	"./bg/introduce.json": "e737",
	"./bg/joinUs.json": "87dd",
	"./bg/newsCom.json": "e101",
	"./bg/productDisplay.json": "075e",
	"./bg/public.json": "b9ed",
	"./bg/responsibility.json": "3939",
	"./de/architecture.json": "cfa2",
	"./de/businessField.json": "b4ba",
	"./de/classify.json": "f425",
	"./de/companyCulture.json": "1e7b",
	"./de/contactUs.json": "536e",
	"./de/footer.json": "4b1c",
	"./de/header.json": "3052",
	"./de/home.json": "dd60",
	"./de/introduce.json": "3fb6",
	"./de/joinUs.json": "6e97",
	"./de/newsCom.json": "9060",
	"./de/productDisplay.json": "6552",
	"./de/public.json": "da15",
	"./de/responsibility.json": "f25e",
	"./en/architecture.json": "6f33",
	"./en/businessField.json": "fca3",
	"./en/classify.json": "43d6",
	"./en/companyCulture.json": "0a17",
	"./en/contactUs.json": "10e4",
	"./en/footer.json": "9fbf",
	"./en/header.json": "fc0c",
	"./en/home.json": "1250",
	"./en/introduce.json": "d77f",
	"./en/joinUs.json": "7326",
	"./en/newsCom.json": "60dd",
	"./en/productDisplay.json": "7062",
	"./en/public.json": "10a8",
	"./en/responsibility.json": "bc46",
	"./es/architecture.json": "dcfc",
	"./es/businessField.json": "8436",
	"./es/classify.json": "b4da",
	"./es/companyCulture.json": "cbb9",
	"./es/contactUs.json": "4df1",
	"./es/footer.json": "eaab",
	"./es/header.json": "d07d",
	"./es/home.json": "847d",
	"./es/introduce.json": "06dd",
	"./es/joinUs.json": "4a11",
	"./es/newsCom.json": "0c4c",
	"./es/productDisplay.json": "0e5a",
	"./es/public.json": "fb86",
	"./es/responsibility.json": "8571",
	"./fr/architecture.json": "41bd",
	"./fr/businessField.json": "3634",
	"./fr/classify.json": "f9f6",
	"./fr/companyCulture.json": "9ea5",
	"./fr/contactUs.json": "0d91",
	"./fr/footer.json": "d8c9",
	"./fr/header.json": "258b",
	"./fr/home.json": "a3dc",
	"./fr/introduce.json": "5b34",
	"./fr/joinUs.json": "8a74",
	"./fr/newsCom.json": "2f39",
	"./fr/productDisplay.json": "aa27",
	"./fr/public.json": "c2d2",
	"./fr/responsibility.json": "6619",
	"./it/architecture.json": "852f",
	"./it/businessField.json": "cca3",
	"./it/classify.json": "4e80",
	"./it/companyCulture.json": "2d50",
	"./it/contactUs.json": "ca24",
	"./it/footer.json": "7c59",
	"./it/header.json": "cee4",
	"./it/home.json": "3eda",
	"./it/introduce.json": "8684",
	"./it/joinUs.json": "020d",
	"./it/newsCom.json": "81c6",
	"./it/productDisplay.json": "63d9",
	"./it/public.json": "ca61",
	"./it/responsibility.json": "3452",
	"./nl/architecture.json": "ac89",
	"./nl/businessField.json": "ece9",
	"./nl/classify.json": "ffa8",
	"./nl/companyCulture.json": "12cd",
	"./nl/contactUs.json": "32a8",
	"./nl/footer.json": "fc84",
	"./nl/header.json": "87cc",
	"./nl/home.json": "7d69",
	"./nl/introduce.json": "698e",
	"./nl/joinUs.json": "acf5",
	"./nl/newsCom.json": "315e",
	"./nl/productDisplay.json": "c7ab",
	"./nl/public.json": "f729",
	"./nl/responsibility.json": "69b6",
	"./pl/architecture.json": "5cb1",
	"./pl/businessField.json": "a27c",
	"./pl/classify.json": "b45c",
	"./pl/companyCulture.json": "0ca7",
	"./pl/contactUs.json": "a79e",
	"./pl/footer.json": "2f25",
	"./pl/header.json": "1662",
	"./pl/home.json": "a6fb",
	"./pl/introduce.json": "fb51",
	"./pl/joinUs.json": "1fb6",
	"./pl/newsCom.json": "c8f4",
	"./pl/productDisplay.json": "99f4",
	"./pl/public.json": "f869",
	"./pl/responsibility.json": "97a0",
	"./pt/architecture.json": "ba1d",
	"./pt/businessField.json": "7a15",
	"./pt/classify.json": "7377",
	"./pt/companyCulture.json": "96f9",
	"./pt/contactUs.json": "6b88",
	"./pt/footer.json": "41c7",
	"./pt/header.json": "f24e",
	"./pt/home.json": "49a9",
	"./pt/introduce.json": "b395",
	"./pt/joinUs.json": "b6b3",
	"./pt/newsCom.json": "97e7",
	"./pt/productDisplay.json": "8d4c",
	"./pt/public.json": "be2d",
	"./pt/responsibility.json": "8c30",
	"./zh/architecture.json": "5b99",
	"./zh/businessField.json": "8392",
	"./zh/classify.json": "01ec",
	"./zh/companyCulture.json": "565b",
	"./zh/contactUs.json": "b716",
	"./zh/footer.json": "84be",
	"./zh/header.json": "f1bd",
	"./zh/home.json": "6ba5",
	"./zh/introduce.json": "ccb2",
	"./zh/joinUs.json": "d94c",
	"./zh/newsCom.json": "f91a",
	"./zh/productDisplay.json": "3c0c",
	"./zh/public.json": "968d",
	"./zh/responsibility.json": "8b2e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "02e8";